module.exports = __webpack_public_path__ + "img/ic_department_blue.c52e60d5.svg";